import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { motion } from "framer-motion";

import { AdvancedControls } from "../AdvancedParameters";
import { useParameters } from "../store";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useModelsStore } from "@/providers/ProviderAndModelsProvider/models-store";

export const Controls = observer(() => {
  const store = useParameters();
  const { store: modelsStore } = useModelsStore({});
  const { modelsLoading } = modelsStore;
  const { modelName, inferenceClientName, provider } = store;
  const hasAdvancedControls = (modelName || inferenceClientName) && !modelsLoading;
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(false);
  }, [provider]);

  return (
    <Accordion
      type="single"
      collapsible
      value={isOpen ? "advanced-controls" : ""}
      className="w-full"
      onValueChange={value => setIsOpen(!!value)}
    >
      <AccordionItem value="advanced-controls" className="border-none">
        <div className="flex items-center justify-end">
          <AccordionTrigger
            disabled={!hasAdvancedControls}
            className="group flex items-center gap-2 px-3 py-2 text-xs font-medium text-blue-600 hover:text-blue-700 hover:no-underline focus:outline-none disabled:cursor-not-allowed disabled:text-gray-400 disabled:hover:bg-transparent [&[data-state=open]>svg]:rotate-180"
            chevronClassName="text-blue-600 group-hover:text-blue-700"
          >
            {isOpen ? "Hide Advanced Controls" : "Show Advanced Controls"}
          </AccordionTrigger>
        </div>
        <AccordionContent className="max-w-fit pt-4">
          <motion.div
            initial={{ width: 0, opacity: 0 }}
            animate={{
              width: isOpen ? "auto" : 0,
              opacity: isOpen ? 1 : 0,
            }}
            transition={{ duration: 0.2 }}
          >
            <AdvancedControls />
          </motion.div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
});
